import { render, staticRenderFns } from "./Vendasmunicipios.vue?vue&type=template&id=4871e190&"
import script from "./Vendasmunicipios.vue?vue&type=script&lang=js&"
export * from "./Vendasmunicipios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports